<template>
	<v-card id="request-details">
		<v-toolbar flat dark color="primary">
			<v-toolbar-title >
				<transaction-type :type="currentType" :white="true" /> {{currentType}} : {{transaction.trackingNumber}}
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn @click="closeRequest" icon><v-icon>far fa-fw fa-times</v-icon></v-btn>
		</v-toolbar>

		<v-card-text>
			<transaction-summary :transaction="transaction" :jobstats="request.jobStats"></transaction-summary>

			<v-divider class="my-3" v-if="request.relatedTransactions.length > 0"></v-divider>

			<related-transactions :transactions="request.relatedTransactions" @clicked="trackClick"></related-transactions>

			<v-divider class="my-3" v-if="currentType === requestTypes.Snapshot && transaction.status === transactionStatus.Completed"></v-divider>

			<snapshot-data :id="transaction.trackingNumber" v-if="currentType === requestTypes.Snapshot && transaction.status === transactionStatus.Completed" />

			<v-divider class="my-3"></v-divider>

			<transaction-files :request="request" v-if="request.hasAnyFiles"></transaction-files>

			<v-divider class="my-3"></v-divider>

			<job-stats v-if="request.jobStats" :stats="request.jobStats" :type="currentType" :created="transaction.created"></job-stats>

			<v-divider v-if="request.jobStats" class="my-3"></v-divider>

			<div>
				<div class="headline">
					Request
				</div>
				<pre class="code mb-3">
{{formattedRequest}}
</pre>
			</div>
		</v-card-text>
		<!--<v-card-actions>-->
		<!--<v-btn @click="cloneRequest" color="primary"><v-icon>fal fa-fw fa-play-circle</v-icon> Clone</v-btn>-->
		<!--</v-card-actions>-->
	</v-card>
</template>

<script>
import { requestTypes, transactionStatus } from "../../enums";
import transactionType from "./transaction-type.vue";
import jobStats from "../jobstats/job-stats.vue";
import transactionSummary from "./transaction-summary.vue";
import RelatedTransactions from "./related-transactions.vue";
import TransactionFiles from "./transaction-files.vue";
import SnapshotData from "./transaction-snapshot-data.vue";

export default {
	props: ["request", "transaction"],
	components: {
		RelatedTransactions,
		transactionType,
		jobStats,
		transactionSummary,
		TransactionFiles,
		SnapshotData,
	},
	data() {
		return {
			requestTypes,
			transactionStatus,
		};
	},
	computed: {
		formattedRequest() {
			return JSON.stringify(this.request[this.currentType.toLowerCase()], null, 2);
		},
		currentType() {
			return this.transaction.transactionType;
		},
	},
	methods: {
		closeRequest() {
			this.$emit("close");
		},
		trackClick(id) {
			this.$emit("view", id);
		},
		cloneRequest() {
			this.$router.push({ name: "clone", params: { trackingNumber: this.viewId } });
		},
	},
};
</script>
